import { Companion_instance1yu5u0cqn8abq as Companion_instance } from './RecyclerViewRendererSet.mjs';
import { Companion_instance10d5r88v1hr3l as Companion_instance_0 } from './RecyclerViewData.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { reactive2xic0rufq5s8n as reactive } from '../../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function children(_this__u8e3s4, items, id, render) {
  _this__u8e3s4.set_rendererSet_dok0gu_k$(Companion_instance.single_mozeja_k$(id, render));
  reactive(_this__u8e3s4, VOID, ($this$reactive) => {
    _this__u8e3s4.set_data_kef13a_k$(Companion_instance_0.fromList_66mo8k_k$($this$reactive.invoke_r7m7el_k$(items)));
    return Unit_instance;
  });
}
//region block: exports
export {
  children as children3c86uuk2wm9cf,
};
//endregion

//# sourceMappingURL=Recycler2.ext.mjs.map
